<mat-form-field appearance="outline" class="sg-full-width slim-form-field sg-short-input">
  <mat-select
    class="units-select"
    [formControl]="legalEntity"
    hideSingleSelectionIndicator
    (selectionChange)="selectionChange.emit($event.value)"
    data-test="borrower-entity-select">
    <mat-select-trigger>
      <div [class.sg-disabled-label]="legalEntity.disabled" class="select-trigger-container sg-flex-row sg-gap-8 sg-justify-start sg-items-center">
        <div matTooltip="{{ legalEntity.value?.borrowerCode }}" matTooltipClass="sg-full-text-tooltip" class="selected-code sg-justify-start sg-items-center">
          {{ legalEntity.value?.borrowerCode }}
        </div>
        <mat-icon class="sg-justify-center sg-items-center select-icon">keyboard_arrow_down</mat-icon>
      </div>
    </mat-select-trigger>
    @for (matchUnits of availabilitySplit; track matchUnits.borrowerCode) {
      <mat-option [value]="matchUnits" class="option" data-test="entity-option">
        <div class="option-container sg-flex-row">
          <div class="option-circle" [ngClass]="{ 'option-circle-selected': legalEntity?.value?.borrowerCode === matchUnits.borrowerCode }"></div>
          <div class="sg-flex-column">
            <div class="option-legal-entity-code" matTooltip="{{ matchUnits.borrowerCode }}" matTooltipClass="sg-full-text-tooltip">
              {{ matchUnits.borrowerCode }}
            </div>
            <div class="option-units-available">{{ matchUnits.units | number }}</div>
          </div>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
